export const urlCheck = (url:string) => {
	if(url) {
		return url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
	}
	return "";
}